module.exports = __webpack_public_path__ + "media/images/pc/items/gift/suns-tshirt-9334286863d5b6b8c790bbcc23fc5f3c.jpg";